import { useState, useEffect, useMemo } from "react";
import '../styles/Goal.css'

import StudentCard2, { StudentCardProps2 } from "./IndividualStudentCard";
import people from "../images/user-icon2.svg";
import noStudent from "../images/no-student.svg";
import addIcon from "../images/add-icon.svg";
import importIcon from "../images/import-icon.svg";
import closeIcon from "../images/close-icon.svg";
import moreIcon from "../images/more-icon.svg";
import editIcon2 from "../images/edit-icon2.svg";
import deleteIcon2 from "../images/delete-icon2.svg";

import Button from "@material-ui/core/IconButton";
import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";
import { createTheme, ThemeProvider } from "@material-ui/core";
import { useFetch } from "../hooks/useFetch";
import CardSkeleton from "./IndividualCardSkeleton";
import Skeleton from "@material-ui/lab/Skeleton";
import { Cookies } from "react-cookie";
import axios from "axios";

interface IndividualGoalProps {
    id: number;
    no: number;
    goal?: string;
    name?: string;
    description: string;
    semesterId: number;
    courseId: number;
    openDialog: boolean;
    setOpenDialog: any;
    openAddStudentDialog: boolean;
    setOpenAddStudentDialog: any;
    openImportExcelDialog: boolean;
    setOpenImportExcelDialog: any;
    openEditDueDateDialog: boolean;
    setOpenEditDueDateDialog: any;
    openDeleteProgressesDialog: boolean;
    setOpenDeleteProgressesDialog: any;
    openGoalDetail: boolean;
    setOpenGoalDetail: any;
    handleGoalIdTarget: any;
    handleStudentTargetList: any;
    sortKey: string;
    search: string;
    beginPath: string;
    isScholarship: boolean;
    courseStudentList: StudentCardProps2[];
    setNumberOfStudentInIndividualGoal?: any;
}
export interface IndividualGoalType {
    id: number,
    no: number,
    goal?: string,
    name?: string,
    description: string,
}

export default function IndividualGoal({ id, no, goal, name, description, semesterId, courseId, openDialog, setOpenDialog, openAddStudentDialog, setOpenAddStudentDialog, openImportExcelDialog, setOpenImportExcelDialog, openEditDueDateDialog, setOpenEditDueDateDialog, openDeleteProgressesDialog, setOpenDeleteProgressesDialog, openGoalDetail, setOpenGoalDetail, handleGoalIdTarget, handleStudentTargetList, sortKey, search, beginPath, isScholarship, courseStudentList, setNumberOfStudentInIndividualGoal }: IndividualGoalProps) {

    const [editCard, setEditCard] = useState(false);
    const [studentList, setStudentList] = useState<StudentCardProps2[]>([])
    const [dropoutStudentList, setDropoutStudentList] = useState<StudentCardProps2[]>([])
    const [completedStudentList, setcompletedStudentList] = useState<StudentCardProps2[]>([])

    const [studentListCopy, setStudentListCopy] = useState<StudentCardProps2[]>([])
    const [dropoutStudentListCopy, setDropoutStudentListCopy] = useState<StudentCardProps2[]>([])
    const [completedStudentListCopy, setcompletedStudentListCopy] = useState<StudentCardProps2[]>([])

    const [checkedState, setCheckedState] = useState(
        new Array(0).fill(false)
    )
    const [checkedCount, setCheckedCount] = useState(0);

    const [loading, setLoading] = useState(false)

    const [checkedStudentList, setCheckedStudentList] = useState<StudentCardProps2[]>([])

    const cookies = new Cookies()

    const fetchQueryPath = isScholarship ? 'scholarshipId' : 'individualGoalId'

    const { data: getStudentsData, status: getStudentsStatus, error: getStudentsError, loading: getStudentsLoading } = useFetch({
        url: `/Students/goal?${fetchQueryPath}=${id}`,
        method: 'GET',
        headers: {
            'Authorization': `Bearer ${cookies.get('user')?.token}`
        }
    }, openDialog, openAddStudentDialog, openImportExcelDialog, openDeleteProgressesDialog, openEditDueDateDialog)

    useEffect(() => {
        if (getStudentsData && courseStudentList) {
            splitStudentList()
            searchStudentList(search)
            sortStudentList(sortKey)
        } else {
            setStudentList([])
            setDropoutStudentList([])
            setcompletedStudentList([])
        }
    }, [getStudentsData, courseStudentList])

    function filterStudentInCourse(students: any[]) {
        if (courseStudentList) {
            return students.filter((student: StudentCardProps2) => courseStudentList.some((studentInCourse: StudentCardProps2) => studentInCourse.id === student.id))
        } else {
            return []
        }
    }

    function splitStudentList() {
        if (getStudentsData) {
            setLoading(true)
            const filteredStudentList = filterStudentInCourse(getStudentsData)

            setCheckedState(new Array(filteredStudentList.length).fill(false))
            setCheckedCount(0)
            setCheckedStudentList([])

            const normal = filteredStudentList.filter((student: StudentCardProps2) => student.studentStatusId !== 5 && !student.isCompleted)
            const completed = filteredStudentList.filter((student: StudentCardProps2) => student.studentStatusId !== 5 && student.isCompleted)
            const dropout = filteredStudentList.filter((student: StudentCardProps2) => student.studentStatusId === 5)

            setStudentList(normal)
            setDropoutStudentList(dropout)
            setcompletedStudentList(completed)

            setStudentListCopy(normal)
            setDropoutStudentListCopy(dropout)
            setcompletedStudentListCopy(completed)
            setLoading(false)
        }
    }

    useMemo(() => splitStudentList(), [getStudentsData, courseStudentList])

    function sortStudentList(key: string) {
        if (key === 'name') {
            setStudentList(prev => {
                return [...prev].sort((a: StudentCardProps2, b: StudentCardProps2) => {
                    const nameA = a.firstName + ' ' + a.lastName
                    const nameB = b.firstName + ' ' + b.lastName
                    return nameA.localeCompare(nameB)
                })
            })
            setcompletedStudentList(prev => {
                return [...prev].sort((a: StudentCardProps2, b: StudentCardProps2) => {
                    const nameA = a.firstName + ' ' + a.lastName
                    const nameB = b.firstName + ' ' + b.lastName
                    return nameA.localeCompare(nameB)
                })
            })
            setDropoutStudentList(prev => {
                return [...prev].sort((a: StudentCardProps2, b: StudentCardProps2) => {
                    const nameA = a.firstName + ' ' + a.lastName
                    const nameB = b.firstName + ' ' + b.lastName
                    return nameA.localeCompare(nameB)
                })
            })
        } else if (key === 'studentId') {
            setStudentList(prev => {
                return [...prev].sort((a: StudentCardProps2, b: StudentCardProps2) => {
                    return (a.id).localeCompare(b.id)
                })
            })
            setcompletedStudentList(prev => {
                return [...prev].sort((a: StudentCardProps2, b: StudentCardProps2) => {
                    return (a.id).localeCompare(b.id)
                })
            })
            setDropoutStudentList(prev => {
                return [...prev].sort((a: StudentCardProps2, b: StudentCardProps2) => {
                    return (a.id).localeCompare(b.id)
                })
            })
        } else if (key === 'deadline') {
            setStudentList(prev => {
                return [...prev].sort((a: StudentCardProps2, b: StudentCardProps2) => {
                    return (a.deadline).localeCompare(b.deadline)
                })
            })
            setcompletedStudentList(prev => {
                return [...prev].sort((a: StudentCardProps2, b: StudentCardProps2) => {
                    return (a.deadline).localeCompare(b.deadline)
                })
            })
            setDropoutStudentList(prev => {
                return [...prev].sort((a: StudentCardProps2, b: StudentCardProps2) => {
                    return (a.deadline).localeCompare(b.deadline)
                })
            })
        }
    }

    useMemo(() => sortStudentList(sortKey), [sortKey])

    function searchStudentList(search: string) {
        if (getStudentsData) {
            if (search === '') {
                splitStudentList()
            } else {
                setStudentList(studentListCopy.filter((student: StudentCardProps2) => {
                    const name = student.title + ' ' + student.firstName + ' ' + student.lastName
                    return name.toLowerCase().includes(search.toLowerCase()) || student.id.toLowerCase().includes(search.toLowerCase())
                }))

                setcompletedStudentList(completedStudentListCopy.filter((student: StudentCardProps2) => {
                    const name = student.firstName + ' ' + student.lastName
                    return name.toLowerCase().includes(search.toLowerCase()) || student.id.toLowerCase().includes(search.toLowerCase())
                }))
                setDropoutStudentList(dropoutStudentList.filter((student: StudentCardProps2) => {
                    const name = student.firstName + ' ' + student.lastName
                    return name.toLowerCase().includes(search.toLowerCase()) || student.id.toLowerCase().includes(search.toLowerCase())
                }))

                updateNumberOfStudentInIndividualGoal()
            }
        }
    }

    useMemo(() => searchStudentList(search), [search])

    function updateNumberOfStudentInIndividualGoal() {
        if (!setNumberOfStudentInIndividualGoal) return
        setNumberOfStudentInIndividualGoal((prev: { [key: number]: number }) => {
            return { ...prev, [id]: studentList.length + completedStudentList.length + dropoutStudentList.length }
        })
    }

    useEffect(() => updateNumberOfStudentInIndividualGoal(), [studentList, completedStudentList, dropoutStudentList])

    const handleOnCheckboxChange = (position: number) => {
        if (search == "") {
            if (checkedState[position] === false) {
                if (position < studentList.length) {
                    setCheckedStudentList(prev => [...prev, studentList[position]])
                } else if (position < studentList.length + completedStudentList.length) {
                    setCheckedStudentList(prev => [...prev, completedStudentList[position - studentList.length]])
                } else {
                    setCheckedStudentList(prev => [...prev, dropoutStudentList[position - studentList.length - completedStudentList.length]])
                }
                setCheckedCount(prev => prev + 1);
            } else {
                if (position < studentList.length) {
                    setCheckedStudentList(prev => prev.filter((item: StudentCardProps2) => item.id !== studentListCopy[position].id))
                } else if (position < studentList.length + completedStudentList.length) {
                    setCheckedStudentList(prev => prev.filter((item: StudentCardProps2) => item.id !== completedStudentListCopy[position - studentList.length].id))
                } else {
                    setCheckedStudentList(prev => prev.filter((item: StudentCardProps2) => item.id !== dropoutStudentListCopy[position - studentList.length - completedStudentList.length].id))
                }
                setCheckedCount(prev => prev - 1);
            }
            const updatedCheckedState = checkedState.map((item, index) =>
                index === position ? !item : item
            );
            setCheckedState(updatedCheckedState);
        }
    }

    useEffect(() => {
        if (!editCard) {
            setCheckedCount(0);
            setCheckedState(prev => prev.map(() => false));
        }
    }, [editCard])

    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
    const open = Boolean(anchorEl);
    const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
        setAnchorEl(event.currentTarget);
        //handleClose()
    };
    const handleClose = () => {
        setAnchorEl(null);
    };

    const handleEditCard = () => {
        setEditCard(true)
        setAnchorEl(null);
    }

    const handleDownloadFileExcel = () => {
        const fetchURL = isScholarship ? "Scholarships" : "IndividualGoals"
        axios.get(`/${fetchURL}/${id}/excel?semesterId=${semesterId}&curriculumId=${courseId}`, {
            headers: {
                'Authorization': `Bearer ${cookies.get('user')?.token}`
            },
            responseType: 'blob',
        }).then((response) => {
            const url = window.URL.createObjectURL(new Blob([response.data]))
            let link = document.createElement('a')
            link.setAttribute('style', 'display: none')
            link.href = url
            link.setAttribute('target', '_blank')
            link.setAttribute('download', `${semesterId}-${courseId}_${fetchURL}_${goal || name}_${new Date().toDateString()}.xlsx`)
            link.click()
            link.remove()
            setTimeout(() => {
                window.URL.revokeObjectURL(url)
            }, 100)
        }).catch((error) => {

        });
        setAnchorEl(null);
    }

    const handleCloseEditCard = () => {
        setEditCard(false)
        setCheckedStudentList([])
    }

    const handleClickAdd = () => {
        handleGoalIdTarget(id)
        setOpenAddStudentDialog(true)
    }

    const handleClickImport = () => {
        handleGoalIdTarget(id)
        setOpenImportExcelDialog(true)
    }

    const handleClickDelete = () => {
        handleStudentTargetList(checkedStudentList)
        handleGoalIdTarget(id)
        setOpenDeleteProgressesDialog(true)
        setCheckedStudentList([])
        setCheckedState(prev => prev.map(() => false));
        setCheckedCount(0)
    }

    const handleClickEditDueDate = () => {
        handleStudentTargetList(checkedStudentList)
        handleGoalIdTarget(id)
        setOpenEditDueDateDialog(true)
        setCheckedStudentList([])
        setCheckedState(prev => prev.map(() => false));
        setCheckedCount(0)
    }

    const handleOpenGoalDetail = () => {
        handleGoalIdTarget(id)
        setOpenGoalDetail(true)
    }

    const moreMenuTheme = createTheme({
        typography: {
            fontSize: 12,

        },
    });

    return (
        <div className={editCard ? "Goal-goal edit" : "Goal-goal"}>
            <header>
                <div className="Goal-title">
                    <button className="elicpse" onClick={handleOpenGoalDetail}>
                        <h4 className="elicpse" title={goal || name}>{goal || name}</h4>
                    </button>
                    {(search === '') && !editCard && <div className="Goal-amount">
                        <img src={people} alt="" />
                        <h5>{studentList.length + dropoutStudentList.length + completedStudentList.length}</h5>
                    </div>}
                    {editCard ? (
                        <div className="Goal-header-actions">
                            <p>{checkedCount} selected</p>
                            <button onClick={handleCloseEditCard} title="Edit">
                                <img src={closeIcon} alt="" />
                            </button>
                        </div>
                    ) : (
                        (search == '') && getStudentsData !== null &&
                        <div className="Goal-more-btn">
                            <ThemeProvider theme={moreMenuTheme}>
                                <Button
                                    aria-label="more"
                                    aria-controls={open ? 'long-menu' : undefined}
                                    aria-expanded={open ? 'true' : undefined}
                                    aria-haspopup="true"
                                    onClick={handleClick}
                                    style={{ padding: "0.125rem" }}
                                >
                                    <img src={moreIcon} alt="" />
                                </Button>
                                <Menu
                                    id="long-menu"
                                    anchorEl={anchorEl}
                                    keepMounted
                                    open={open}
                                    onClose={handleClose}
                                    anchorOrigin={{
                                        vertical: 'bottom',
                                        horizontal: 'right',
                                    }}
                                    transformOrigin={{
                                        vertical: 'top',
                                        horizontal: 'center',
                                    }}
                                    style={{ marginTop: "2.25rem", marginLeft: "0.5rem" }}
                                >
                                    <MenuItem onClick={handleEditCard}>Edit</MenuItem>
                                    <MenuItem onClick={handleDownloadFileExcel}>Export</MenuItem>
                                </Menu>
                            </ThemeProvider>
                        </div>
                    )}
                </div>
            </header>
            {
                (getStudentsData === null || loading) &&
                <div className="Goal-list">
                    <CardSkeleton />
                    <CardSkeleton />
                    <CardSkeleton />
                </div>
            }

            {(getStudentsData !== null && (studentList.length + dropoutStudentList.length + completedStudentList.length) !== 0) && <div className="Goal-list">
                {isScholarship ? (
                    <>
                        {studentList.map(({ id: studentId, scholarshipProgressId, title, firstName, lastName, studentStatus, studentStatusId, deadline, isCompleted }: StudentCardProps2, index: number) => (
                            <StudentCard2
                                key={scholarshipProgressId}
                                link={`${beginPath}/${studentId}/${scholarshipProgressId}`}
                                index={index}
                                id={studentId}
                                scholarshipProgressId={scholarshipProgressId}
                                scholarshipId={id}
                                title={title}
                                firstName={firstName}
                                lastName={lastName}
                                studentStatusId={studentStatusId}
                                studentStatus={studentStatus}
                                deadline={deadline}
                                isCompleted={isCompleted}
                                editCard={editCard}
                                checkboxValue={checkedState[index]}
                                onClick={() => setOpenDialog(true)}
                                handleOnCheckboxChange={handleOnCheckboxChange}
                            />
                        ))}
                        {completedStudentList.map(({ id: studentId, scholarshipProgressId, title, firstName, lastName, studentStatus, studentStatusId, deadline, isCompleted }: StudentCardProps2, index: number) => (
                            <StudentCard2
                                key={scholarshipProgressId}
                                link={`${beginPath}/${studentId}/${scholarshipProgressId}`}
                                index={studentList.length + index}
                                id={studentId}
                                scholarshipProgressId={scholarshipProgressId}
                                scholarshipId={id}
                                title={title}
                                firstName={firstName}
                                lastName={lastName}
                                studentStatusId={studentStatusId}
                                studentStatus={studentStatus}
                                deadline={deadline}
                                isCompleted={isCompleted}
                                editCard={editCard}
                                checkboxValue={checkedState[studentList.length + index]}
                                onClick={() => setOpenDialog(true)}
                                handleOnCheckboxChange={handleOnCheckboxChange}
                            />
                        ))}
                        {dropoutStudentList.map(({ id: studentId, scholarshipProgressId, title, firstName, lastName, studentStatus, studentStatusId, deadline, isCompleted }: StudentCardProps2, index: number) => (
                            <StudentCard2
                                key={scholarshipProgressId}
                                link={`${beginPath}/${studentId}/${scholarshipProgressId}`}
                                index={studentList.length + completedStudentList.length + index}
                                id={studentId}
                                scholarshipProgressId={scholarshipProgressId}
                                scholarshipId={id}
                                title={title}
                                firstName={firstName}
                                lastName={lastName}
                                studentStatusId={studentStatusId}
                                studentStatus={studentStatus}
                                deadline={deadline}
                                isCompleted={isCompleted}
                                editCard={editCard}
                                checkboxValue={checkedState[studentList.length + completedStudentList.length + index]}
                                onClick={() => setOpenDialog(true)}
                                handleOnCheckboxChange={handleOnCheckboxChange}
                            />
                        ))}
                    </>
                ) : (
                    <>
                        {studentList.map(({ id: studentId, individualProgressId, title, firstName, lastName, studentStatus, studentStatusId, deadline, isCompleted }: StudentCardProps2, index: number) => (
                            <StudentCard2
                                key={individualProgressId}
                                link={`${beginPath}/${studentId}/${individualProgressId}`}
                                index={index}
                                id={studentId}
                                individualProgressId={individualProgressId}
                                individualGoalId={id}
                                title={title}
                                firstName={firstName}
                                lastName={lastName}
                                studentStatusId={studentStatusId}
                                studentStatus={studentStatus}
                                deadline={deadline}
                                isCompleted={isCompleted}
                                editCard={editCard}
                                checkboxValue={checkedState[index]}
                                onClick={() => setOpenDialog(true)}
                                handleOnCheckboxChange={handleOnCheckboxChange} />
                        ))}
                        {completedStudentList.map(({ id: studentId, individualProgressId, title, firstName, lastName, studentStatus, studentStatusId, deadline, isCompleted }: StudentCardProps2, index: number) => (
                            <StudentCard2
                                key={individualProgressId}
                                link={`${beginPath}/${studentId}/${individualProgressId}`}
                                index={studentList.length + index}
                                id={studentId}
                                individualProgressId={individualProgressId}
                                individualGoalId={id}
                                title={title}
                                firstName={firstName}
                                lastName={lastName}
                                studentStatusId={studentStatusId}
                                studentStatus={studentStatus}
                                deadline={deadline}
                                isCompleted={isCompleted}
                                editCard={editCard}
                                checkboxValue={checkedState[studentList.length + index]}
                                onClick={() => setOpenDialog(true)}
                                handleOnCheckboxChange={handleOnCheckboxChange} />
                        ))}
                        {dropoutStudentList.map(({ id: studentId, individualProgressId, title, firstName, lastName, studentStatus, studentStatusId, deadline, isCompleted }: StudentCardProps2, index: number) => (
                            <StudentCard2
                                key={individualProgressId}
                                link={`${beginPath}/${studentId}/${individualProgressId}`}
                                index={studentList.length + completedStudentList.length + index}
                                id={studentId}
                                individualProgressId={individualProgressId}
                                individualGoalId={id}
                                title={title}
                                firstName={firstName}
                                lastName={lastName}
                                studentStatusId={studentStatusId}
                                studentStatus={studentStatus}
                                deadline={deadline}
                                isCompleted={isCompleted}
                                editCard={editCard}
                                checkboxValue={checkedState[studentList.length + completedStudentList.length + index]}
                                onClick={() => setOpenDialog(true)}
                                handleOnCheckboxChange={handleOnCheckboxChange} />
                        ))}
                    </>
                )}
            </div>}
            {((studentList.length + completedStudentList.length + dropoutStudentList.length) === 0 && (getStudentsData !== null)) &&
                <div className="Goal-no-student">
                    <img src={noStudent} alt="No Student" />
                </div>
            }
            {(getStudentsData === null) ? (
                <div className="Goal-bottom-container">
                    <Skeleton variant="rect" width={100} height={20} />
                    <Skeleton variant="rect" width={100} height={20} />
                </div>
            ) : (<>
                {editCard ? (
                    <div className="Goal-bottom-container">
                        <button
                            className="Goal-btn"
                            disabled={checkedCount === 0}
                            style={{ color: '#8B8B8B', gap: '0.25rem' }}
                            onClick={handleClickEditDueDate}
                        >
                            <img src={editIcon2} alt="editIcon" />
                            Edit Due Date
                        </button>
                        <button
                            className="Goal-btn"
                            disabled={checkedCount === 0}
                            style={{ color: '#FF5959', gap: '0.25rem' }}
                            onClick={handleClickDelete}
                        >
                            <img src={deleteIcon2} alt="deleteIcon" />
                            Delete
                        </button>
                    </div>
                ) : (
                    <div className="Goal-bottom-container">
                        <button className="Goal-btn" onClick={handleClickAdd}>
                            <img src={addIcon} alt="addIcon" />
                            Add Progress
                        </button>
                        <button className="Goal-btn" style={{ gap: '0.25rem' }} onClick={handleClickImport}>
                            <img src={importIcon} alt="importIcon" />
                            Import
                        </button>
                    </div>
                )}
            </>)
            }
        </div>
    )
}
